<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{ width: '900px', maxWidth: '95vw' }"
  [header]="row?.merchantName ?? 'Merchant income'"
  [dismissableMask]="true"
  data-cy="dashboard-income-chart"
>
  <div class="income-chart-body">
    <p *ngIf="loading" class="muted">Loading…</p>
    <p *ngIf="error" class="error" data-cy="dashboard-income-error">{{ error }}</p>

    <ng-container *ngIf="!loading && !error">
      <div class="controls">
        <button
          *ngIf="canGoBack"
          pButton
          type="button"
          label="< Back"
          class="p-button-text p-button-sm"
          (click)="back()"
          data-cy="dashboard-income-back"
        ></button>

        <span class="level-label">{{ currentLevel?.label }}</span>

        <ng-container *ngIf="compareAnchor === null; else comparing">
          <button
            pButton
            type="button"
            label="Compare to…"
            class="p-button-text p-button-sm"
            (click)="openComparePicker()"
            data-cy="dashboard-income-compare"
          ></button>
          <p-calendar
            #compareCalendar
            *ngIf="showComparePicker"
            [(ngModel)]="compareAnchor"
            [defaultDate]="compareDefaultDate"
            [showIcon]="true"
            [readonlyInput]="true"
            dateFormat="mm/dd/yy"
            placeholder="Pick a start date"
            (onSelect)="applyCompare()"
          ></p-calendar>
        </ng-container>
        <ng-template #comparing>
          <span class="compare-label">Comparing from {{ compareAnchor | date : 'MM/dd/yyyy' }}</span>
          <button
            pButton
            type="button"
            label="Clear"
            class="p-button-text p-button-sm"
            (click)="clearCompare()"
          ></button>
        </ng-template>
      </div>

      <div class="chart-host">
        <app-dashboard-graph
          [data$]="chartData$"
          type="line"
          xTitle=""
          yTitle="Amount ($)"
          [showLegend]="false"
          (dataSelect)="onBarSelect($event)"
        ></app-dashboard-graph>
      </div>

      <p class="hint muted">Click a bar to drill in. Greyed bars fall outside this location's activity.</p>
    </ng-container>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="breakdownVisible"
  [modal]="true"
  [style]="{ width: '360px' }"
  [header]="breakdownLabel"
  data-cy="dashboard-income-breakdown"
>
  <p class="muted">{{ breakdownTxns.length }} transaction{{ breakdownTxns.length === 1 ? '' : 's' }}</p>
  <div *ngIf="breakdownTxns.length; else noTxns" class="breakdown-list">
    <div class="breakdown-row" *ngFor="let t of breakdownTxns">
      <span>{{ t.time }}</span>
      <span>{{ t.amount }}</span>
    </div>
  </div>
  <ng-template #noTxns>
    <p class="muted">No transactions in this period.</p>
  </ng-template>
</p-dialog>
